import Swal from "sweetalert2";

const CustomAlert = ({
  title,
  text,
  icon,
  confirmButtonText,
  showCancelButton,
  cancelButtonText,
  allowOutsideClick = true,
  cancelButtonColor,
}) => {
  return Swal.fire({
    title: title,
    text: text,
    icon: icon,
    confirmButtonText: confirmButtonText || "OK",
    showCancelButton: showCancelButton || false,
    cancelButtonText: cancelButtonText || "Cancel",
    allowOutsideClick: allowOutsideClick,
    cancelButtonColor: cancelButtonColor || "#aaa",
  });
};

export default CustomAlert;
